import { storageManager } from "./storageManager";

const UI_STORAGE_PREFIX = "ui";
const getChatWidthKey = () => `${UI_STORAGE_PREFIX}::chat_width`;
const getAspectRatioKey = () => `${UI_STORAGE_PREFIX}::chat_aspect_ratio`;

export async function loadChatWidth(): Promise<number | null> {
  const stored = await storageManager.get<number>(getChatWidthKey());
  return typeof stored === "number" ? stored : null;
}

export async function persistChatWidth(width: number) {
  await storageManager.set(getChatWidthKey(), width);
}

export async function loadAspectRatio(): Promise<string | null> {
  const stored = await storageManager.get<string>(getAspectRatioKey());
  return typeof stored === "string" ? stored : null;
}

export async function persistAspectRatio(value: string) {
  await storageManager.set(getAspectRatioKey(), value);
}
